import React, { useMemo } from 'react';
import classNames from 'classnames';

import { ClockCircleOutlined } from '@ant-design/icons';
import { ITime } from '../../../../../../../../../components/SlideoutMenu/menus/SlideoutDateTime/SlideoutDateTime';
import { formatDateTime } from '../../../../../../../../../../common/helpers/formatDateTime';
import { formatTimePeriod } from '../../../../../../../../../../common/widgets/DelayWidget/TimePeriodSelector/TimePeriodSelector';

import common from '../../index.module.css';
import css from './Date.module.css';
import moment from 'moment';
import { Tooltip } from 'antd';

type Props = {
  className?: string;
  classNameCount?: string;
  placeholder?: string;
  time: ITime;
  onClick?: () => void;
  awaitingCount?: string | number;
};

export const Date: React.FC<Props> = ({
  awaitingCount,
  className,
  classNameCount,
  time,
  placeholder,
  onClick,
  children,
}) => {
  const expired = useMemo(() => {
    if (!time.date) {
      return false;
    }

    return moment(time.date).isBefore(moment());
  }, [time.date]);

  const value = useMemo(() => {
    if (time.date) {
      return formatDateTime(time.date, 'MMMM Do YYYY, h:mm a');
    }

    return formatTimePeriod(time.value, time.measure);
  }, [time.date, time.value, time.measure]);

  return (
    <div
      className={classNames(className, common.card, css.container, {
        [css.expired]: expired,
      })}
    >
      <div className={css.body} onClick={onClick}>
        <div className={css.info}>
          <div className={css.icon}>
            <ClockCircleOutlined />
          </div>

          <div className={css.headerContent}>
            <div className={css.headerText}>
              {placeholder && (
                <span className={css.placeholder}>
                  {expired ? 'Expired' : placeholder}:
                </span>
              )}

              {value && <span className={css.value}>{value}</span>}
            </div>

            {expired && (
              <span className={css.expired}>
                <span className={css.expiredText}>
                  The time above has passed, so this block will be skipped from
                  now on. Click here to update or delete the block.
                </span>
              </span>
            )}
          </div>
        </div>
      </div>

      {!expired && (
        <div className={classNames(classNameCount, css.analytics)}>
          <Tooltip title="Waiting" overlayClassName={css.tooltip}>
            <div className={css.analyticsRow}>
              <span className={css.analyticsIcon}>
                <ClockCircleOutlined color="#595959" />
              </span>

              <span className={css.analyticsText}>
                <span className={css.analyticsValue}>{awaitingCount || 0}</span>
              </span>
            </div>
          </Tooltip>
        </div>
      )}

      {children}
    </div>
  );
};
